module.exports = __webpack_public_path__ + "quilt3-level7.cc44bcc3.png";